<main class="page">
  <div class="glow" aria-hidden="true"></div>
  <div class="grain" aria-hidden="true"></div>
  <app-brand class="backdrop" [draw]="true" aria-hidden="true" />

  <section class="card">
    <div class="brand">
      <app-brand class="logo" />
      <span class="product">SSO</span>
    </div>

    <h1 class="title">Uscita non completata</h1>
    <p class="lead">
      La sessione <b>non</b> è stata chiusa:
      {{ info.cause.charAt(0).toLowerCase() + info.cause.slice(1) }}
    </p>

    <p class="lead next">
      @if (info.retry) {
        Torna all'applicazione da cui sei partito e riprova. Se l'errore si ripete, segnalalo a un
        amministratore.
      } @else {
        Riprovare non aiuta: è la configurazione dell'applicativo a non essere corretta. Segnalalo a
        un amministratore.
      }
    </p>

    @if (code !== null) {
      <p class="code">
        Codice da riportare: <code>{{ code }}</code>
      </p>
    }
  </section>
</main>
